import styled from 'styled-components';
import { LineScoreWrapper, StyledInningCell } from '@mlb/react-patterns/v4/components/LineScore/lineScore.style';

export const GamedayLineScoreWrapper = styled.div`
    font-family: var(--gameday-primary-font);
    text-align: center;
    ${LineScoreWrapper} {
        margin-bottom: 16px;
        max-width: 375px;
        >div:first-child {
            position: relative;
            &:after {
                position: absolute;
                right: 0;
                top: 0;
                content: '';
                display: block;
                height: 1px;
                width: 1px;
            }
        }

        table {
            thead {
                th {
                    padding: 0 0 6px 0;
                    line-height: 11px;
                    >div {
                        line-height: 14px;
                        font-size: 14px;
                        color: var(--gameday-boxscore-thead-color);
                        font-weight: 500;
                    }
                }
            }

            tbody {
                th, td {
                    line-height: 14px;
                    font-size: 14px;
                    padding: 6px 0 8px 0;
                    background-color: transparent;
                    color: var(--gameday-boxscore-tbody-color);
                }

                th {
                    ${StyledInningCell} {
                        font-weight: 700;
                    }
                }
                
                tr {
                    &:last-child {
                        th, td {
                            padding-top: 8px;
                        }
                    }
                }

                td {
                    &[data-highlighted='true'] {
                        div {
                            width: 20px;
                            height: 20px;
                            line-height: 20px;
                            background: var(--gameday-table-active-cell-color);
                            border-radius: 4px;
                            position: absolute;
                            top: 4px;
                            left: 4px;
                        }
                    }
                }
                ${StyledInningCell} {
                    color: var(--gameday-boxscore-tbody-color);
                    min-height: initial;
                    font-size: 14px;
                    font-weight: 500;
                    }
                }

            }  
        }
        >:last-child {
            table {
                tr {
                    td {
                        &:first-child {
                            ${StyledInningCell} {
                                font-weight: 700;
                                color: var(--gameday-boxscore-tbody-color);
                            }
                        }
                    }
                }
            }
        }  
    }
`;

export const LineScoreSkeleton = styled.div`
    display: flex;
`;

export const MiniSkeletonSection = styled.div`
    >div {
        &:first-child {
            margin-top: 2px;
        }
    }
`;

export const MainSkeletonSection = styled(MiniSkeletonSection)`
    width: calc(100% - 80px);
    >div {
        &:first-child {
            margin-left: 60px;
        }
    }
`;